let code = 'app';
let codeAPI = 'genericapplication';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};